export const PATIENT_LAST_REPORT_OPTIONS = {
  APPOINTMENT_DATE_TIME: "Patient.LastReport.AppointmentDateTime",
  APPOINTMENT_TYPE: "Patient.LastReport.AppointmentType",
  LEFT_HEARING_LOSS: "Patient.LastReport.LeftHearingLoss",
  RIGHT_HEARING_LOSS: "Patient.LastReport.RightHearingLoss",
  LEFT_WRS_PRESENTATION_LEVEL_LOSS:
    "Patient.LastReport.LeftWRSAndPresentationLevel",
  RIGHT_WRS_PRESENTATION_LEVEL_LOSS:
    "Patient.LastReport.RightWRSAndPresentationLevel",
  LEFT_QUICKSIN_AND_SNR_LOSS: "Patient.LastReport.LeftQuickSinAndSnrLoss",
  RIGHT_QUICKSIN_AND_SNR_LOSS: "Patient.LastReport.RightQuickSinAndSnrLoss",
  LEFT_TYMPANOGRAM_TYPE: "Patient.LastReport.LeftTympanogramType",
  RIGHT_TYMPANOGRAM_TYPE: "Patient.LastReport.RightTympanogramType",
  LEFT_HEARING_LOSS_LEVEL: "Patient.LastReport.LeftHearingLossLevel",
  RIGHT_HEARING_LOSS_LEVEL: "Patient.LastReport.RightHearingLossLevel",
  LEFT_HEARING_LOSS_SHAPE: "Patient.LastReport.LeftHearingLossShape",
  RIGHT_HEARING_LOSS_SHAPE: "Patient.LastReport.RightHearingLossShape",
  LEFT_HEARING_LOSS_TYPE: "Patient.LastReport.LeftHearingLossType",
  RIGHT_HEARING_LOSS_TYPE: "Patient.LastReport.RightHearingLossType",
  SUMMARY: "Patient.LastReport.Summary"
};

export const PATIENT_LAST_SIGNED_REPORT_MENU_OPTIONS = {
  title: "Patient - Last Signed Report",
  menu: [
    {
      title: "Patient - Last Signed Report - Appointment Date Time",
      value: PATIENT_LAST_REPORT_OPTIONS.APPOINTMENT_DATE_TIME
    },
    {
      title: "Patient - Last Signed Report - Appointment Type",
      value: PATIENT_LAST_REPORT_OPTIONS.APPOINTMENT_TYPE
    },
    {
      title: "Patient - Last Signed Report - Left Ear",
      menu: [
        {
          title: "Patient - Last Signed Report - Left Hearing Loss",
          value: PATIENT_LAST_REPORT_OPTIONS.LEFT_HEARING_LOSS
        },
        {
          title:
            "Patient - Last Signed Report - Left WRS and Presentation Level",
          value: PATIENT_LAST_REPORT_OPTIONS.LEFT_WRS_PRESENTATION_LEVEL_LOSS
        },
        {
          title: "Patient - Last Signed Report - Left QuickSIN and SNR Loss",
          value: PATIENT_LAST_REPORT_OPTIONS.LEFT_QUICKSIN_AND_SNR_LOSS
        },
        {
          title: "Patient - Last Signed Report - Left Tympanogram Type",
          value: PATIENT_LAST_REPORT_OPTIONS.LEFT_TYMPANOGRAM_TYPE
        },
        {
          title: "Patient - Last Signed Report - Left Hearing Loss Level",
          value: PATIENT_LAST_REPORT_OPTIONS.LEFT_HEARING_LOSS_LEVEL
        },
        {
          title: "Patient - Last Signed Report - Left Hearing Loss Shape",
          value: PATIENT_LAST_REPORT_OPTIONS.LEFT_HEARING_LOSS_SHAPE
        },
        {
          title: "Patient - Last Signed Report - Left Hearing Loss Type",
          value: PATIENT_LAST_REPORT_OPTIONS.LEFT_HEARING_LOSS_TYPE
        }
      ]
    },
    {
      title: "Patient - Last Signed Report - Right Ear",
      menu: [
        {
          title: "Patient - Last Signed Report - Right Hearing Loss",
          value: PATIENT_LAST_REPORT_OPTIONS.RIGHT_HEARING_LOSS
        },

        {
          title:
            "Patient - Last Signed Report - Right WRS and Presentation Level",
          value: PATIENT_LAST_REPORT_OPTIONS.RIGHT_WRS_PRESENTATION_LEVEL_LOSS
        },

        {
          title: "Patient - Last Signed Report - Right QuickSIN and SNR Loss",
          value: PATIENT_LAST_REPORT_OPTIONS.RIGHT_QUICKSIN_AND_SNR_LOSS
        },

        {
          title: "Patient - Last Signed Report - Right Tympanogram Type",
          value: PATIENT_LAST_REPORT_OPTIONS.RIGHT_TYMPANOGRAM_TYPE
        },

        {
          title: "Patient - Last Signed Report - Right Hearing Loss Level",
          value: PATIENT_LAST_REPORT_OPTIONS.RIGHT_HEARING_LOSS_LEVEL
        },

        {
          title: "Patient - Last Signed Report - Right Hearing Loss Shape",
          value: PATIENT_LAST_REPORT_OPTIONS.RIGHT_HEARING_LOSS_SHAPE
        },

        {
          title: "Patient - Last Signed Report - Right Hearing Loss Type",
          value: PATIENT_LAST_REPORT_OPTIONS.RIGHT_HEARING_LOSS_TYPE
        }
      ]
    },

    {
      title: "Patient - Last Signed Report - Summary",
      value: PATIENT_LAST_REPORT_OPTIONS.SUMMARY
    }
  ]
};
